/**
 * @deprecated Quarantined legacy. Prefer a modern help affordance over an Elevio article marker.
 *
 * Moved out of the Angular tree in WEB-8858 so the ReactTemplates.elevio global could survive
 * Phase 6; WEB-9512 converted the last of its 79 consumers to import it directly and removed the
 * global entirely, so this is now a plain component with no window coupling.
 */
'use strict';
import React from 'react';

const elevio = window.ReactCreateClass({
	render: function () {
		var style = { borderBottom: 'none' };
		if (this.props.sidebar) {
			if (this.props.text) {
				return (
					<span data-elevio-article={this.props.articleId} style={this.props.style}>
						{this.props.text}
					</span>
				);
			} else if (this.props.children) {
				return (
					<span data-elevio-article={this.props.articleId} style={style}>
						{this.props.children}
					</span>
				);
			}
			return (
				<b
					data-elevio-article={this.props.articleId}
					style={this.props.style}
					className="fa fa-question-circle"
				/>
			);
		}
		if (this.props.text) {
			return <span data-elevio-inline={this.props.articleId}>{this.props.text}</span>;
		} else if (this.props.children) {
			return (
				<span data-elevio-inline={this.props.articleId} style={style}>
					{this.props.children}
				</span>
			);
		}
		return (
			<b data-elevio-inline={this.props.articleId} style={this.props.style} className="fa fa-question-circle" />
		);
	}
});

export default elevio;
